// Date range presets, used by DateRangeFilter.vue and the "Filtered by" labels (tableMixin.js)
export const DATE_PRESET_GROUPS = [
   {
      label: "Days",
      options: [
         { value: "today", label: "Today" },
         { value: "yesterday", label: "Yesterday" },
         { value: "last7", label: "Last 7 days" },
         { value: "last30", label: "Last 30 days" },
      ],
   },
   {
      label: "Week",
      options: [
         { value: "thisWeekToDate", label: "This week to date" },
         { value: "thisWeek", label: "This week" },
         { value: "lastWeek", label: "Last week" },
      ],
   },
   {
      label: "Month",
      options: [
         { value: "thisMonthToDate", label: "This month to date" },
         { value: "thisMonth", label: "This month" },
         { value: "lastMonth", label: "Last month" },
      ],
   },
   {
      label: "Quarter",
      options: [
         { value: "thisQuarterToDate", label: "This quarter to date" },
         { value: "thisQuarter", label: "This quarter" },
         { value: "lastQuarter", label: "Last quarter" },
         { value: "q1", label: "First quarter" },
         { value: "q2", label: "Second quarter" },
         { value: "q3", label: "Third quarter" },
         { value: "q4", label: "Fourth quarter" },
      ],
   },
   {
      label: "Year",
      options: [
         { value: "thisYearToDate", label: "This year to date" },
         { value: "lastYear", label: "Last year" },
      ],
   },
   {
      label: "Other",
      options: [
         { value: "all", label: "All time" },
         { value: "custom", label: "Custom…" },
      ],
   },
];

// "q2", 2026 -> "Second quarter 2026"   |   "thisMonth" -> "This month"
export function datePresetLabel(value, year) {
   for (const group of DATE_PRESET_GROUPS) {
      const option = group.options.find((o) => o.value === value);
      if (option) {
         return ["q1", "q2", "q3", "q4"].includes(value) ? `${option.label} ${year}` : option.label;
      }
   }
   return "";
}